module.exports = __webpack_public_path__ + "img/nu.668c6591.svg";